export const DEFAULT_MATTE_COLOR = "#09080f";

const BACKGROUND_STYLE_KEYS = [
  "backgroundColor",
  "backgroundImage",
  "backgroundSize",
  "backgroundPosition",
  "backgroundRepeat",
];

export function getProjectBackgroundStyle(settings) {
  const safeSettings = settings ?? {};
  const backgroundColor = safeSettings.matte_color || DEFAULT_MATTE_COLOR;
  const image = safeSettings.background_image || "";
  return {
    backgroundColor,
    ...(image
      ? {
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }
      : {}),
  };
}

/** Per-block background for scroll render — one continuous image across all blocks. */
export function getScrollBlockBackgroundStyle(settings, offsetY, videoWidth) {
  const safeSettings = settings ?? {};
  const backgroundColor = safeSettings.matte_color || DEFAULT_MATTE_COLOR;
  const image = safeSettings.background_image || "";

  if (!image) {
    return { backgroundColor };
  }

  return {
    backgroundColor,
    backgroundImage: `url(${image})`,
    backgroundSize: `${videoWidth}px auto`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: `center ${-offsetY}px`,
  };
}

export function snapshotBackgroundStyles(element) {
  const snapshot = {};
  for (const key of BACKGROUND_STYLE_KEYS) {
    snapshot[key] = element.style[key] || "";
  }
  return snapshot;
}

export function applyBackgroundStyles(element, backgroundStyle = {}) {
  for (const key of BACKGROUND_STYLE_KEYS) {
    if (backgroundStyle[key]) {
      element.style[key] = backgroundStyle[key];
    } else {
      element.style[key] = "";
    }
  }
}

export function restoreBackgroundStyles(element, snapshot = {}) {
  for (const key of BACKGROUND_STYLE_KEYS) {
    element.style[key] = snapshot[key] || "";
  }
}

export function getHtml2CanvasBackgroundColor(backgroundStyle = {}) {
  if (backgroundStyle.backgroundImage) return null;
  const color = backgroundStyle.backgroundColor;
  if (!color || color === "transparent" || color === "rgba(0, 0, 0, 0)") {
    return null;
  }
  return color;
}
